import React from 'react';
import VideoList from '../video-page/VideoList';
import { connect } from "react-redux";
import { watchlistUser } from "../../actions/userActions";
import { pageview } from '../../utils/googleAnalyticsUtils';

class WatchHistory extends React.Component {

    async componentDidMount(){
        pageview('Settings-Watch History');
        await this.props.watchlistUser();
    }

    renderWatchListItem(video){
        
    }

    render() {
        return (
            <div>
                {this.props.watchlist && <VideoList videos={this.props.watchlist} videosCount={this.props.watchlist.length}  />}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        watchlist: state.userAccountDetails.userWatchlist
    };
}
export default connect(mapStateToProps, {
    watchlistUser
})(WatchHistory);